import { groupBy, uniq } from "lodash";
import type { Maybe, OddsSelection, PopularBet } from "@/graphql/gql/graphql";

type Odds = Maybe<OddsSelection>[];

/**
 * @param headToHeadSlug like "8867/falcons-saints"
 */
export const buildHead2HeadPath = (headToHeadSlug: string) =>
  `/nfl/matchups/${headToHeadSlug}`;

export const getUniquePlayerNumberfireIds = (odds: Odds) =>
  uniq(odds.map((el) => el?.player?.numberfireId)).filter((id) => id != null);

export const groupByPlayerNumberfireId = (odds: Odds) =>
  groupBy(odds, "player.numberfireId");

/**
 * Generates the H2H matchup URL for a given game
 * Returns null if the required data is not available
 */
export const generateH2HMatchupUrl = (
  nfGameId: string,
  awayTeamShortName: string,
  homeTeamShortName: string
): string => {
  const awayTeamSlug = awayTeamShortName.toLowerCase();
  const homeTeamSlug = homeTeamShortName.toLowerCase();

  return buildHead2HeadPath(`${nfGameId}/${awayTeamSlug}-${homeTeamSlug}`);
};

export const dummyParlay: PopularBet = {
  americanOdds: 2000,
  betUrl: null,
  count: 1425,
  type: "samegameparlay",
  events: [
    {
      competitionName: "NFL",
      eventName: "KC Chiefs @ PHI Eagles",
      openDate: "2025-02-09T23:35:00.000Z",
      selections: [
        {
          formattedHandicap: null,
          handicap: 0,
          marketName: "Any Time Touchdown Scorer",
          runnerName: "Player",
        },
        {
          formattedHandicap: null,
          handicap: 0,
          marketName: "Player - Alt Rushing Yds",
          runnerName: "Player 40+ Yards",
        },
        {
          formattedHandicap: null,
          handicap: 0,
          marketName: "Player - Alt Passing Yds",
          runnerName: "Player 250+ Yards",
        },
        {
          formattedHandicap: null,
          handicap: 0,
          marketName: "Player - Alt Receptions",
          runnerName: "Player 5+ Receptions",
        },
      ],
    },
  ],
};
